module.exports = __webpack_public_path__ + "4407d289f471ca6406c2ee04b5020a10.svg";